// Lib
import React from 'react';
import { useSelector } from 'react-redux';

// Selectors
import { selectIsMobileAppMode } from '../platform/platformSelector';

// Components
import PublishPreviewToast from './preview/PublishPreviewToast';
import ClearSearchToast from '../components/search/ClearSearchToast';
import FileTransferToast from '../element/attachments/FileTransferToast';
import BoardPermissionToast from './permissions/toast/BoardPermissionToast';
import ZoomToast from '../canvas/zoom/toast/ZoomToast';

const WorkspaceToasts: React.FC = () => {
    const isMobileAppMode = useSelector(selectIsMobileAppMode);

    return (
        <>
            <BoardPermissionToast />
            <PublishPreviewToast />
            <FileTransferToast />
            <ClearSearchToast />
            {isMobileAppMode && <ZoomToast />}
        </>
    );
};

export default WorkspaceToasts;
